import type {StatsProps} from './types.ts';

export const STATS:StatsProps[] = [
    {
        title: "Пользователи",
        value: "4 305",
        unit: "+",
        label: "активных клиентов",
        description: "УК и ЖСК по всей России",
    },
    {
        title: "Заявки",
        value: "30",
        unit: "сек",
        label: "на подачу заявки",
        description: "против 20 минут по телефону",
    },
    {
        title: "Экономия",
        value: "166 800",
        unit: "₽",
        label: "средняя экономия",
        description: "в год на операционных расходах",
    },
    {
        title: "Удовлетворенность",
        value: "98",
        unit: "%",
        label: "довольных жильцов",
        description: "по результатам опроса 2024",
    },
];